import { useMemo } from 'react';
import type { BrandingType } from '@dr-pam/common-types/database/client';
import type MarkdownService from '../Services/MarkdownService';
import type { Branding } from '../Services/TemplateRenderService';
import TemplateRenderService from '../Services/TemplateRenderService';

/**
 * Lives here rather than alongside TemplateRenderService so that server-side callers (the api bundles
 * common-components source) don't pull React into a Node build.
 */
export function useTemplateRenderService(branding: Map<BrandingType, Branding>, markdownService: MarkdownService) {
	return useMemo(() => new TemplateRenderService(branding, markdownService), [branding, markdownService]);
}

export default useTemplateRenderService;
